import {Component, input, OnInit} from '@angular/core';

@Component({
  selector: 'app-event-item-skl',
  templateUrl: './event-item-skl.component.html',
  styleUrls: ['./event-item-skl.component.scss'],
})
export class EventItemSklComponent  implements OnInit {

  mode = input<'horizontal' | 'vertical' >();

  constructor() { }

  ngOnInit() {}

}
